import React from 'react';
import ErrorPage from './ErrorPage.js';

const BACKEND = process.env.REACT_APP_BACKEND_URL || "https://api.resto-online.be";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);

    // Best-effort crash-melding naar de backend (die er een mail over stuurt).
    // Faalt dit? Dan gewoon negeren — de gebruiker ziet sowieso de ErrorPage.
    try {
      fetch(`${BACKEND}/monitoring/client-error`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: error?.message || String(error),
          stack: error?.stack || '',
          componentStack: errorInfo?.componentStack || '',
          url: window.location.href,
          userAgent: navigator.userAgent,
        }),
        keepalive: true,
      }).catch(() => {});
    } catch (_) {
      /* stilte: melden mag nooit zelf een fout veroorzaken */
    }
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
